(() => {
  if (window.__hubLayoutInit) return;
  window.__hubLayoutInit = true;

  const isDesktop = () => window.innerWidth > 1024;

  const setTocTop = () => {
    const nav = document.querySelector(".content-navigation");
    if (!nav) return;
    nav.style.top = isDesktop() ? "40px" : "0px";
  };

  window.addEventListener("resize", setTocTop);
  setTocTop();
})();
